import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { BREAKPOINTS } from '../../../BeFi20.meta';
import { Wrapper as WrapperBase } from '../../../BeFi20.styles';

export const Wrapper = styled(WrapperBase)({
  justifyContent: 'flex-start',
  gap: 56,
  paddingTop: 32,
  paddingBottom: 0,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    padding: 32,
  },

  [`@media (min-height: 800px)`]: {
    justifyContent: 'center',
  },
});

export const Header = styled(motion.header)({
  boxSizing: 'border-box',
  display: 'grid',
  placeContent: 'center',
});

export const Main = styled(motion.section)(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 16,
  background: theme.colors.bg,
  flex: 1,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    borderRadius: 12,
    boxShadow: theme.shadows['500'],
    maxWidth: 640,
    padding: 32,
    gap: 24,
    width: '100%',
    margin: '0 auto',
    flex: 'unset',
  },
}));

export const Title = styled(Text)({
  fontSize: '32px',
  fontWeight: 600,
  lineHeight: '40px',
  textAlign: 'center',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '-0.5px',
  },
});

export const Description = styled(Text)({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
});

export const HelperText = styled(Text)({
  fontSize: '16px',
  lineHeight: '24px',
});

export const CTAButton = styled(Button)({
  marginTop: 'auto',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    alignSelf: 'center',
    marginTop: 'unset',
  },
});
